<template>
  <v-dialog
    scrollable
    persistent
    max-width="1200px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
  >
    <v-card id="qj-dialog-node">
      <!-- Cabeçalho -->
      <v-card-title class="pa-0">
        <v-toolbar dense prominent extended style="z-index: 1" class="elevation-2">
          <v-toolbar-title>
            <v-text-field
              full-width
              single-line
              hide-details
              label="Nome"
              value="Novo nó"
              v-model="nodeForm.name"
            ></v-text-field>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="isNew=false; $emit('update:dialog', false);">
            <v-icon>close</v-icon>
          </v-btn>
          <!-- Caminho -->
          <template v-slot:extension>
            <v-breadcrumbs :items="breadcrumbs" class="pa-0 ma-0">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item class="subheading purple--text" :href="null">
                  {{ item.text.toUpperCase() }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </template>
        </v-toolbar>
      </v-card-title>
      <!-- Corpo -->
      <v-card-text
        :style="$vuetify.breakpoint.smAndDown ? '' : 'height: 651px'"
        class="pa-0"
      >
        <!-- Erro -->
        <v-expand-transition>
          <v-alert
            dense
            color="red"
            type="error"
            class="ma-0 pb-2 pt-1"
            :value="true"
            v-show="failure.show"
          >
            <div style="display: flex" class="align-center">
              <p class="subheading">{{ failure.text }}</p>
              <v-spacer />
              <v-btn
                flat
                icon
                class="ma-0"
                color="white"
                @click="failure = { show: false, text: '' }"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-alert>
        </v-expand-transition>
        <!-- Conteudo -->
        <v-container fluid grid-list-md class="pa-3">
          <!-- Formulário -->
          <v-form lazy-validation ref="form" class="mb-3">
            <v-layout row wrap>
              <!-- Tipo da busca do nó -->
              <v-flex xs12 md4 v-if="!this.node.debt_base_id || this.isNew" >
                <v-select
                  box
                  required
                  hide-details
                  item-text="name"
                  item-value="value"
                  label="Tipo da busca do nó"
                  :items="nodeTypes"
                  :disabled="isEdit"
                  v-model="nodeForm.type"
                ></v-select>
              </v-flex>
              <v-flex xs12 md5 v-else>
                <v-select
                  box
                  required
                  hide-details
                  item-text="name"
                  item-value="value"
                  label="dia da semana"
                  multiple
                  :items="prepareWeekDays"
                  v-model="modelWeek"
                >
              </v-select>
              </v-flex>
              <!-- DELAY -->
              <v-flex
                xs12
                :class="isEdit ? 'md4' : 'md3'"
                v-if="nodeForm.type == 'DELAY'"
              >
                <v-text-field
                  box
                  hide-details
                  type="number"
                  autocomplete="off"
                  name="min_days_of_delay"
                  label="Mínimo de dias de atraso"
                  :disabled="isEdit"
                  v-model="nodeForm.min_days_of_delay"
                />
              </v-flex>
              <v-flex
                xs12
                :class="isEdit ? 'md4' : 'md3'"
                v-if="nodeForm.type == 'DELAY'"
              >
                <v-text-field
                  box
                  hide-details
                  type="number"
                  autocomplete="off"
                  name="max_days_of_delay"
                  label="Máximo de dias de atraso"
                  :disabled="isEdit"
                  v-model="nodeForm.max_days_of_delay"
                />
              </v-flex>
              <!-- POTENTIAL -->
              <v-flex
                xs12
                :class="isEdit ? 'md4' : 'md3'"
                v-if="nodeForm.type == 'POTENTIAL'"
              >
                <v-text-field
                  box
                  hide-details
                  type="number"
                  autocomplete="off"
                  name="min_potential"
                  label="Potencial de ganho mínimo"
                  :disabled="isEdit"
                  v-model="nodeForm.min_potential"
                />
              </v-flex>
              <v-flex
                xs12
                :class="isEdit ? 'md4' : 'md3'"
                v-if="nodeForm.type == 'POTENTIAL'"
              >
                <v-text-field
                  box
                  hide-details
                  type="number"
                  autocomplete="off"
                  name="max_potential"
                  label="Potencial de ganho máximo"
                  :disabled="isEdit"
                  v-model="nodeForm.max_potential"
                />
              </v-flex>
            <!-- DISCOUNT -->
              <v-flex
                xs12
                :class="isEdit ? 'md4' : 'md3'"
                v-if="nodeForm.type == 'DISCOUNT'"
              >
                <v-text-field
                  box
                  type="number"
                  autocomplete="off"
                  name="min_discount"
                  label="Desconto mínimo"
                  hint="50 equivale a 50%"
                  :disabled="isEdit"
                  v-model="isEdit ? nodeForm.min_discount*100 : nodeForm.min_discount"
                />
              </v-flex>
              <v-flex
                xs12
                :class="isEdit ? 'md4' : 'md3'"
                v-if="nodeForm.type == 'DISCOUNT'"
              >
                <v-text-field
                  box
                  hide-details
                  type="number"
                  autocomplete="off"
                  name="max_discount"
                  label="Desconto máximo"
                  :disabled="isEdit"
                  v-model="isEdit ? nodeForm.max_discount*100 : nodeForm.max_discount"
                />
              </v-flex>
              <!-- PV -->
              <v-flex xs12 :class="isEdit ? 'md4' : 'md3'" v-if="nodeForm.type == 'PV'">
                <v-text-field
                  box
                  hide-details
                  type="number"
                  name="min_debit"
                  autocomplete="off"
                  label="Valor presente mínimo"
                  :disabled="isEdit"
                  v-model="nodeForm.min_debit"
                />
              </v-flex>
              <v-flex xs12 :class="isEdit ? 'md4' : 'md3'" v-if="nodeForm.type == 'PV'">
                <v-text-field
                  box
                  hide-details
                  type="number"
                  name="max_debit"
                  autocomplete="off"
                  label="Valor presente máximo"
                  :disabled="isEdit"
                  v-model="nodeForm.max_debit"
                />
              </v-flex>
              <!-- DEAL_TYPE -->
              <v-flex
                xs12
                :class="isEdit ? 'md5' : 'md4'"
                v-if="nodeForm.type == 'DEAL_TYPE'"
              >
                <v-select
                  box
                  required
                  hide-details
                  label="Tipos"
                  item-text="name"
                  item-value="value"
                  :items="dealTypes"
                  :disabled="isEdit"
                  v-model="nodeForm.option"
                ></v-select>
              </v-flex>
              
              <!-- POLICY_TYPE -->
              <v-flex
                xs12
                :class="isEdit ? 'md5' : 'md4'"
                v-if="nodeForm.type == 'POLICY_TYPE'"
              >
                <v-select
                  box
                  required
                  hide-details
                  label="Política"
                  item-text="name"
                  item-value="value"
                  :items="policiesItems"
                  :disabled="isEdit"
                  v-model="nodeForm.option"
                ></v-select>
              </v-flex>              
              <!-- Btn simular -->
              <v-flex
                xs12
                md2
                v-if="!isEdit"
                :class="nodeForm.type == 'DEAL_TYPE' ? 'offset-md2' : ''"
              >
                <v-btn
                  large
                  block
                  color="primary"
                  class="elevation-1 mx-0"
                  :loading="loadingSimulate"
                  @click="simulate"
                >
                  Simular</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
          <!-- Informações -->
          <v-layout
            row
            wrap
            class="mx-0"
            style="border: 1px solid #e0e0e0; border-radius: 4px"
            v-if="nodeData"
          >
            <!-- Total de clientes -->
            <v-flex xs12 class="ma-2">
              <div v-show="lastTotalCustomers == -1">
                <p class="font-weight-medium title">
                  {{ animatedNumber | numeral("0,0") }} clientes
                </p>
              </div>
              <div
                v-show="lastTotalCustomers > -1"
                style="display: flex"
                class="align-center"
              >
                <v-expand-x-transition>
                  <div class="d-flex align-center" v-show="lastTotalCustomers > 0">
                    <p class="font-weight-medium title text-no-wrap">
                      {{ animatedNumber | numeral("0,0") }} clientes
                    </p>
                    <v-icon class="mx-1" size="20">mdi-arrow-left</v-icon>
                  </div>
                </v-expand-x-transition>
                <p class="font-weight-medium title">
                  {{ lastTotalCustomers | numeral("0,0") }} clientes
                </p>
              </div>
            </v-flex>
            <!-- Divisória -->
            <v-flex xs12 class="pa-0">
              <v-divider></v-divider>
            </v-flex>
            <!-- Informações -->
            <v-flex xs12 class="ma-2">
              <v-layout row wrap>
                <!-- Não localizados -->
                <v-flex xs12 md6>
                  <TreeNotLocated :data="nodeData" />
                </v-flex>
                <!-- Localizados -->
                <v-flex xs12 md6>
                  <TreeLocated :data="nodeData" />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider />
      <!-- Rodapé -->
      <v-card-actions>
        <v-spacer />
        <v-btn
          depressed
          color="primary"
          :loading="loadingCreation"
          :disabled="!simulationDone || loadingCreation"
          @click="create"
          v-if="!isEdit"
        >
          Adicionar
        </v-btn>
        <v-btn depressed color="primary" @click="saveEdition" v-else>
          Atualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import gsap from "gsap";
import utils from "../utils/util";
import tasksService from "@/services/tasks";
import TreeLocated from "../trees/treeLocated";
import TreeNotLocated from "../trees/treeNotLocated";
import treeService from "@/services/consolidation-tree/consolidation-tree";

export default {
  props: ["node", "dialog", "isEdit", "debtBaseId", "selectedWeekDays"],
  components: {
    TreeLocated,
    TreeNotLocated,
  },
  data: function () {
    return {
      locked: true,
      simulationDone: false,
      loadingSimulate: false,
      loadingCreation: false,
      totalCustomers: 0,
      lastTotalCustomers: -1,
      breadcrumbs: [],
      nodeTypes: [
        { name: "Dias atraso", value: "DELAY" },
        { name: "Desconto à vista", value: "DISCOUNT" },
        { name: "Valor presente", value: "PV" },
        { name: "Potencial de ganho", value: "POTENTIAL" },
        { name: "Tipo negociação", value: "DEAL_TYPE" },
        { name: "Política", value: "POLICY_TYPE" },
      ],
      prepareWeekDays: [
        "Segunda","Terça","Quarta","Quinta","Sexta","Sábado", "Domingo"
      ],
      dealTypes: [
        { name: "Todas", value: "" },
        { name: "Normal", value: "NEGOTIATION" },
        { name: "Renegociação", value: "RENEGOTIATION" },
        { name: "Fomento", value: "FOMENTATION" },
        { name: "Sem dados", value: "DATALESS" },
      ],
      policiesItems:[
        {name: "Com política", value: "ONLY_POLICIES"},
        {name: "Sem política", value: "NOT_ONLY_POLICIES"},
      ],   
      nodeForm: {},
      nodeData: {},
      failure: {
        show: false,
        text: "",
      },
      modelWeek: null,
      days: [0,1,2,3,4,5,6],
      isNew: false,
    };
  },
  computed: {
    animatedNumber() {
      return this.totalCustomers.toFixed(0);
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        if (this.isEdit) this.edit();
        else this.new();
        this.modelWeek = Object.values(this.selectedWeekDays);
      } else this.reset();
    },
    "nodeForm.type"() {
      if (this.nodeForm.type == "DEAL_TYPE") this.nodeForm.option = "";
    },
    "nodeForm.type"() {
      if (this.nodeForm.type == "POLICY_TYPE") this.nodeForm.option = "";
    },
    "nodeData.customers"(newValue) {
      let duration = this.lastTotalCustomers < 0 && !this.locked ? 0 : 0.5;
      gsap.to(this.$data, {
        duration: duration,
        totalCustomers: newValue ? newValue : 0,
      });
    },
  },
  methods: {
    reset() {
      this.lastTotalCustomers = -1;
      this.nodeData = {};
      this.failure = {
        show: false,
        text: "",
      };
    },
    new() {
      this.breadcrumbs = utils.mountBreadCrumb(this.node);
      this.locked = true;
      this.isNew = true;
      this.nodeData = {};
      this.totalCustomers = 0;
      this.lastTotalCustomers = -1;
      this.nodeForm = {
        parent_id: this.node.id,
        name: "Novo nó",
        type: "DELAY",
      };
    },
    edit() {
      treeService
        .getNode(this.node.id, ["last_resolution", "parent"])
        .then((currentNode) => {
          this.breadcrumbs = utils.mountBreadCrumb(currentNode.parent);
          this.nodeData = currentNode.last_resolution;
          this.nodeForm = currentNode;
          this.nodeForm.min_discount = this.nodeForm.value.start;
          this.nodeForm.max_discount = this.nodeForm.value.end;
          this.nodeForm.min_days_of_delay = this.nodeForm.value.start;
          this.nodeForm.max_days_of_delay = this.nodeForm.value.end;
          this.nodeForm.min_potential = this.nodeForm.value.start;
          this.nodeForm.max_potential = this.nodeForm.value.end;
          this.nodeForm.min_debit = this.nodeForm.value.start;
          this.nodeForm.max_debit = this.nodeForm.value.end;
        });
    },
    simulate() {
      this.loadingSimulate = true;
      this.failure = {
        show: false,
        text: "",
      };
      let payload = {
        name: this.nodeForm.name,
        parent_id: this.nodeForm.parent_id,
        type: this.nodeForm.type,
        value: this.getNodeValue(this.nodeForm, this.nodeForm.type),
      };

      if (!this.locked) {
        var value = this.nodeData.customers;
        if (this.lastTotalCustomers < 0) this.nodeData.customers = 0;
        setTimeout(() => {
          this.lastTotalCustomers = value;
        });
      }

      treeService
        .nodeSimulate(payload)
        .then(async (res) => this.checkSimulation(res.task_id))
        .catch((err) => {
          this.$store.commit("showSnackbar", "Houve um erro ao simular o nó");
          console.error(err);
          this.loadingSimulate = false;
        });
    },
    getNodeValue(nodeForm, nodeType) {
      let value = {};

      if (nodeType == "DISCOUNT") {
        value = {
          start: parseInt(nodeForm.min_discount) / 100 || null,
          end: parseInt(nodeForm.max_discount) / 100 || null,
        };
      } else if (nodeType == "DELAY") {
        value = {
          start: nodeForm.min_days_of_delay ? parseInt(nodeForm.min_days_of_delay) : null,
          end: nodeForm.max_days_of_delay ? parseInt(nodeForm.max_days_of_delay) : null,
        };
      } else if (nodeType == "POTENTIAL") {
        value = {
          start: nodeForm.min_potential ? parseFloat(nodeForm.min_potential) : null,
          end: nodeForm.max_potential ? parseFloat(nodeForm.max_potential) : null,
        };
      } else if (nodeType == "PV") {
        value = {
          start: nodeForm.min_debit ? parseFloat(nodeForm.min_debit) : null,
          end: nodeForm.max_debit ? parseFloat(nodeForm.max_debit) : null,
        };
      } else if (nodeType == "DEAL_TYPE") {
        value = { option: nodeForm.option };
      } else if (nodeType == "POLICY_TYPE") {
        value = { option: nodeForm.option };
      }

      return value;
    },
    checkSimulation(taskId) {
      var interval = setInterval(() => {
        tasksService
          .get(taskId)
          .then((res) => {
            if (res.state == "SUCCESS") {
              clearInterval(interval);
              this.nodeData = res.result;
              this.simulationDone = true;
              this.loadingSimulate = false;
              setTimeout(() => {
                if (this.lastTotalCustomers < 0) this.locked = false;
              });
            } else if (res.state == "FAILURE") {
              this.failure = {
                show: true,
                text: "Simulação falhou",
              };
              clearInterval(interval);
              this.loadingSimulate = false;
            }
          })
          .catch((err) => {
            this.failure = {
              show: true,
              text: "Simulação falhou",
            };
            console.error(err);
            clearInterval(interval);
            this.loadingSimulate = false;
          });
      }, 1000);
    },
    create() {
      this.loadingCreation = true;
      this.isNew = false;
      let node = {
        debt_base_id: this.debtBaseId,
        parent_id: this.nodeForm.parent_id,
        type: this.nodeForm.type,
        value: this.getNodeValue(this.nodeForm, this.nodeForm.type),
        name: this.nodeForm.name,
      };

      treeService.createNode(node).then((newDebtNode) => {
        this.checkCreation(newDebtNode.task_id, newDebtNode.id);
      });
    },
    checkCreation(taskId, nodeId) {
      var interval = setInterval(async () => {
        tasksService
          .get(taskId)
          .then(async (res) => {
            if (res.state == "SUCCESS") {
              clearInterval(interval);
              treeService
                .getNode(nodeId, true)
                .then((resolved) => {
                  this.$emit("updateTree", { new: true, node: resolved });
                  this.$emit("update:dialog", false);
                  this.loadingCreation = false;
                })
                .catch((err) => {
                  console.error(err);
                  this.loadingCreation = false;
                });
            } else if (res.state == "FAILURE") {
              this.failure = {
                show: true,
                text: "Houve um erro na criação do nó",
              };
              clearInterval(interval);
              this.loadingCreation = false;
            }
          })
          .catch((err) => {
            this.failure = {
              show: true,
              text: "Houve um erro na criação do nó",
            };
            console.error(err);
            clearInterval(interval);
            this.loadingCreation = false;
          });
      }, 1000);
    },
    saveEdition() {


      var aux = "[";
      this.modelWeek.forEach((weekDay, index) => {
        if (this.prepareWeekDays.indexOf(weekDay) > -1) {
          if (index == 0) {
            aux+=this.prepareWeekDays.indexOf(weekDay);
          } else {
            aux+="," + this.prepareWeekDays.indexOf(weekDay);
          }
        }
      })
      aux += "]";

      aux = JSON.parse(aux).sort((a,b) => a - b)
 
      treeService
        .patchDebtBase(this.nodeForm.debt_base_id, { prepare_week_day: "["+aux.toString()+"]" })
        .then((resp) => {
          this.$emit("updatedDebtBase", resp.prepare_week_day);
        })
        .catch((e) => {
          console.error("Erro ao salvar nó", e);
          this.failure = {
            show: true,
            text: "Houve um erro ao salvar nó",
          };
        });
      treeService
        .patchNode(this.nodeForm.id, { name: this.nodeForm.name})
        .then(() => {
          this.$emit("updateTree", { new: false, node: this.nodeForm });
          this.$emit("update:dialog", false);
        })
        .catch((e) => {
          console.error("Erro ao salvar nó", e);
          this.failure = {
            show: true,
            text: "Houve um erro ao salvar nó",
          };
        });
    },
  },
};
</script>

<style>
#qj-dialog-node .v-toolbar__title {
  width: 100%;
}
#qj-dialog-node .v-toolbar__content {
  padding-right: 0;
  padding-left: 6px;
}
#qj-dialog-node .v-toolbar__content > :last-child.v-btn--icon {
  margin-right: 6px;
}
#qj-dialog-node .v-text-field--full-width > .v-input__control > .v-input__slot {
  min-height: 48px;
}
#qj-dialog-node .v-toolbar__title .v-input,
#qj-dialog-node .v-toolbar__title .v-label {
  font-size: 20px;
}
#qj-dialog-node .v-toolbar__title .v-input input {
  margin: auto;
}
#qj-dialog-node .v-toolbar__title .v-label {
  margin-top: -4px;
}
#qj-dialog-node .v-toolbar__title .v-input input,
#qj-dialog-node .v-toolbar__title .v-label {
  padding-left: 6px;
}
#qj-dialog-node .v-toolbar__title .v-input input:hover,
#qj-dialog-node .v-toolbar__title .v-label:hover {
  padding-left: 5px;
}
#qj-dialog-node .v-toolbar__title .v-input input:hover {
  border: 1px solid #6a4cb7;
  border-radius: 4px;
  padding-right: 5px;
}
#qj-dialog-node .v-toolbar__title .v-input input:focus,
#qj-dialog-node .v-toolbar__title .v-label:focus {
  padding-left: 4px;
}
#qj-dialog-node .v-toolbar__title .v-input input:focus {
  border: 2px solid #6a4cb7;
  border-radius: 4px;
  padding-right: 4px;
}
</style>
